import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import ChatIcon from '@mui/icons-material/Chat';
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutIcon from '@mui/icons-material/Logout';
import LogoutModal from '../LogoutModal';
import { useUser } from '../../context/UserContext';

const Sidebar = ({ selectedMenu, setSelectedMenu }) => {
  const navigate = useNavigate();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const { user } = useUser();

  const getMenuItems = () => {
    const items = [
      { 
        title: 'Chatbot', 
        icon: (isSelected) => <ChatIcon sx={{ color: isSelected ? '#fff' : '#000' }} />, 
        path: '/chatbot' 
      },
      { 
        title: 'Edit Profile', 
        icon: (isSelected) => <PersonIcon sx={{ color: isSelected ? '#fff' : '#000' }} />, 
        path: '/profile' 
      },
      { 
        title: 'Change Password', 
        icon: (isSelected) => <LockResetIcon sx={{ color: isSelected ? '#fff' : '#000' }} />, 
        path: '/change_password' 
      },
      { 
        title: 'Logout', 
        icon: (isSelected) => <LogoutIcon sx={{ color: isSelected ? '#fff' : '#000' }} />, 
        path: '/' 
      },
    ];

    if (user?.role === 'admin') {
      items.unshift({ 
        title: 'Dashboard', 
        icon: (isSelected) => <DashboardIcon sx={{ color: isSelected ? '#fff' : '#000' }} />, 
        path: '/dashboard' 
      });
    }

    return items;
  };

  const handleLogoutClick = () => {
    setIsLogoutModalOpen(true);
  };

  const handleLogoutConfirm = () => {
    localStorage.clear();
    setSelectedMenu(null);
    setIsLogoutModalOpen(false);
    navigate('/signin');
  };

  const handleClick = (index, path) => {
    if (path === '/') {
      handleLogoutClick();
    } else {
      setSelectedMenu(index);
      navigate(path);
    }
  };

  const menuItems = getMenuItems();

  return (
    <Box
      sx={{
        width: 240,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f8f9fa',
        boxShadow: 'none',
        borderRight: '1px solid #e0e0e0',
        padding: '8px',
      }}
    >
      <List sx={{ width: '100%' }}>
        {menuItems.map((item, index) => (
          <ListItem
            button
            key={item.title}
            onClick={() => handleClick(index, item.path)}
            sx={{
              backgroundColor: selectedMenu === index ? '#161ab3' : 'transparent',
              color: selectedMenu === index ? '#fff' : '#000',
              cursor: 'pointer',
              borderRadius: '8px',
              marginBottom: '4px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: selectedMenu === index ? '#161ab3' : 'rgba(0, 0, 0, 0.04)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <ListItemIcon>
              {item.icon(selectedMenu === index)}
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        ))}
      </List>
      <LogoutModal 
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onLogout={handleLogoutConfirm}
      />
    </Box>
  );
};

export default Sidebar;
